import {useNavigate} from 'react-router-dom'
import {LinkText} from '@/components/atoms'

/**
 * ReadOnlyField component displays a label and corresponding data in a read-only format.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.label - The label to display.
 * @param {string|number} props.data - The data to display next to the label.
 * @param {string} props.href - The href is redirect url while on LinkText click event.
 *
 * @returns {JSX.Element} The rendered read-only field component.
 */
const ReadOnlyFieldLinkText = props => {
  const navigate = useNavigate()
  const {label, data, uischema} = props
  const {href = '#'} = uischema || {}
  return (
    <>
      <div className="oDP flex flex-row gap-4">
        <div className="flex">
          <div className="w100">
            <div className="ptb">
              <div className="flex gap-4">
                <label className="lableColor">{label}</label>
              </div>
              <div className="flex gap-4">
                <LinkText text={data} id={label + '_' + data} handleClick={() => navigate(href)} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ReadOnlyFieldLinkText
